import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsLinkDetails = ({ onBack = () => {}, onNext = () => {}, canGoNext, inputs }) => {
  const { t } = useTranslation(['rewards-gift', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view card-details settings">
        <div className="rewards-modal-input-row">
          {inputs.first && (
            <div className="input-container">
              <div className="input-label">{inputs.first.label}</div>
              {inputs.first.render()}
            </div>
          )}
        </div>
        {inputs.second && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className="input-label">{inputs.second.label}</div>
              {inputs.second.render()}
            </div>
          </div>
        )}
        {inputs.third && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className="input-label">{inputs.third.label}</div>
              {inputs.third.render()}
            </div>
          </div>
        )}
        {inputs.forth && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className="input-label">{inputs.forth.label}</div>
              {inputs.forth.render()}
            </div>
          </div>
        )}
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-gift:sendGiftForm.reviewSummaryButton')}
        </button>
      </div>
    </div>
  )
}

RewardsLinkDetails.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  canGoNext: PropTypes.bool,
  inputs: PropTypes.object,
}

export default RewardsLinkDetails
